import BoardField from './BoardField';

export default class Board {
    constructor(boardOb=null) {
        this.id = '';        
        this.fields = [];        
        if (boardOb !== null && 'fields' in boardOb) {
            const fields = boardOb.fields;
            for (let i = 0; i < fields.length; i++) {
                const fieldOb = fields[i];
                const boardField = new BoardField(fieldOb);
                this.fields.push(boardField);                
            }
        }        
    }

    playerScore(userId) {
        let score = 0;
        for (let i = 0; i < this.fields.length; i++) {
            if (!this.fields[i].isActive && this.fields[i].isPlayerSelected(userId)) {
                score++;                
            }
        }
        score = score / 3;
        return score;
    }
}